import { Validators } from '../../../../../utils/validators';
import { FormModel } from '../../../../../components/Form';
export const MailTemplateForm = (strings: any): FormModel[] => {
  return [
    {
      label: strings.mailTemplate_text_subject,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'subject',
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateString, max: 500 }],
      responsive: { xs: 12, md: 4 },
      required: true,
    },
    // {
    //   label: strings.mailTemplate_text_content,
    //   value: '',
    //   autoFocus: true,
    //   type: 'textEditor',
    //   placeholder: '',
    //   field: 'content',
    //   validators: [{ check: Validators.validateMandatoryField }],
    //   responsive: { xs: 12 },
    //   required: true,
    // },
    {
      label: strings.mailTemplate_text_content,
      value: '',
      size: 'medium',
      autoFocus: false,
      type: 'text',
      typeValue: 'text',
      multiline: true,
      minRows: 6,
      maxRows: 50,
      variant: 'outlined',
      placeholder: '',
      field: 'template',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12 },
      required: true,
    },
  ];
};
